import {useState, useEffect, createContext, useContext} from "react";
import {Outlet} from "react-router-dom";
import "./App2.css";
import Header from "./app2/Header/Header";
import Intro from "./app2/Intro/Intro";
import Second from "./app2/Second/Second";
import Latest from "./app2/Latest/Latest";
import Email from "./app2/Email/Email";
import Footer from "./app2/Footer/Footer";
import Breadcrumb from "./app2/BreadCrumb/BreadCrumb.jsx";


import { useParams, Link, useMatches } from "react-router-dom";

import { getBkendUrl, getJsonPath, getRootUrl, getTokenName, getPdtCatsUrl, loginUrl, ErrorBoundary, useData } from "./consts";
import axios_with_token, { regUses, useSiteData} from "./axios_with_token";
// import { useLogin } from "./Login/Login.jsx";
import LoginProvider, {useLoginContext} from "./Login/Login.jsx";

// import ModalRcdEdit from "./input_types/ModalRcdEdit/ModalRcdEdit.jsx";
// https://stackoverflow.com/questions/45255190/entry-module-not-found-error-cant-resolve-src-index-js

import {CartBody} from "./app2/ShoppingCart/ShoppingCart.jsx";
// import { Password } from "@mui/icons-material";

// const rootUrl = getRootUrl();
// const bkendUrl = getBkendUrl();
// const jsonPath = getJsonPath();



function Content({}){
    const {regUse, isReady} = regUses();
    // console.log('In App2 ... ...');
    // const {LoginResult, Login, loggedin, setLoggedin, regSetLoggedin} = regUse(useLogin({
    //     // username: 'guest',
    //     // password: 'guest'
    //     username: 'martin',
    //     password: 'letmein'

    // }));
    // const {data:siteData} = regUses(useSiteData(isLogginIn));

    // const [mode, setMode] = useState("index");

    const params = useParams();
    const matches = useMatches();

    // https://reactrouter.com/en/main/hooks/use-matches#breadcrumbs
    const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map((match) => match.handle.crumb(match.data));

    
    const pathName = (((matches[matches.length-1]||{}).pathname||"").split('/').filter(a=>a));

    return <ErrorBoundary>
        <Header 
            // setMode={setMode}
            className="pb-0"
        />
        
        {/* <Router>
            <Switch>
            {routerDef.map(({ path, element }, key) => (
                <Route exact path={path} key={key} render={element} />
            ))}
            </Switch>
        </Router> */}

        <Breadcrumb />

        {/* {(params.id===undefined)&&<Intro />} */}
        <Outlet />

        <CartBody />

        <Footer/>
    </ErrorBoundary>
}

export default function App2(){
    // const {regUse, isReady} = regUses();
    // console.log('In App2 ... ...');
    // const {LoginResult, Login, loggedin, setLoggedin, regSetLoggedin} = regUse(useLogin({
    //     // username: 'guest',
    //     // password: 'guest'
    //     username: 'martin',
    //     password: 'letmein'

    // }));

    return <LoginProvider>
        <Content></Content>
    </LoginProvider>;
}